export class CronSettings {
  runOrganizationPaymentCron: boolean;

  constructor(json: any) {
    this.runOrganizationPaymentCron = json.runOrganizationPaymentCron
      ? Boolean(json.runOrganizationPaymentCron)
      : false;
  }
}
